import { api } from '../DefaultService';
import { IPaginationParams } from '../types';
import {
  IRecognitionDeleteParams,
  IRecognitionFilterParams,
  IRecognitionSimpleProps,
} from './types';

const ENDPOINT = 'v1/recognitions';

export const getAllRecognitionsByLicenseAsync = async (
  pagination?: IPaginationParams,
  filter?: IRecognitionFilterParams,
): Promise<IRecognitionSimpleProps[]> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`, {
      params: { ...pagination, ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllRecognitionsByLicenseCountAsync = async (
  filter: IRecognitionFilterParams,
): Promise<number> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense/count`, { params: { ...filter } })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteRecognitionAsync = async ({
  id,
  type,
}: IRecognitionDeleteParams) => {
  await api
    .delete(`${ENDPOINT}/${id}`, { params: { discriminator: type } })
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
